module.exports = __webpack_public_path__ + "static/media/blueitem3.c14e60a8.png";